import {
  CustomizationActiveIngredientAddMoreTitle,
  CustomizationActiveIngredientContainer,
  CustomizationActiveIngredientContentContainer,
  CustomizationActiveIngredientImage,
  CustomizationActiveIngredientPlusIcon,
  CustomizationActiveIngredientPressable,
  CustomizationActiveIngredientRemoveButton,
  CustomizationActiveIngredientTitle,
} from './components';

export const CustomizationActiveIngredient = {
  Container: CustomizationActiveIngredientContainer,
  ContentContainer: CustomizationActiveIngredientContentContainer,
  Pressable: CustomizationActiveIngredientPressable,
  Image: CustomizationActiveIngredientImage,
  AddMoreTitle: CustomizationActiveIngredientAddMoreTitle,
  Title: CustomizationActiveIngredientTitle,
  RemoveButton: CustomizationActiveIngredientRemoveButton,
  PlusIcon: CustomizationActiveIngredientPlusIcon,
};
